<template>
  <div class="hello">

    <div v-if="success">
      <h1 class="is-size-1 has-text-centered">{{ $t('This form has been sent successfully.') }} <i>¡Gracias! </i>
      </h1>
    </div>

    <form v-else @submit.prevent="submit" novalidate>
        <!-- <div class="field">
            <label class="label">Nombre de la educator <span class="required">*</span>
            </label>
            <div class="control">
                <input v-model="title" class="input" type="text">
                <div class="has-text-error-message" v-if="v$.title.$error">{{ $t('nec') }}</div>
                <div class="help">Incluir aquí el nombre que quieres que aparezca en la web. No es necesario incluir siglas
                    que referencien a la sociedad como "S.A" o “S.L”
                </div>
            </div>
        </div> -->

        <div class="field">
            <label class="label">{{ $t('First name')}}</label>
            <div class="control">
                <input v-model="firstName" class="input" type="text">
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Surname')}} <span class="required">*</span></label>
            <div class="control">
                <input v-model="surName" class="input" type="text">
                <div class="has-text-error-message" v-if="v$.surName.$error">{{ $t('nec') }}</div>
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Job title')}}</label>
            <div class="control">
                <input v-model="jobTitle" class="input" type="text">
            </div>
        </div>
        
        <div class="field">
            <label class="label">{{ $t('Company')}}</label>
            <div class="control">
                <input v-model="company" class="input" type="text">
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Address')}} <span class="required">*</span></label>
            <div class="control">
                <input v-model="address" class="input" type="text">
                <div class="has-text-error-message" v-if="v$.address.$error">{{ $t('nec') }}</div>
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('City')}} <span class="required">*</span></label>
            <div class="control">
                <input v-model="city" class="input" type="text">
                <div class="has-text-error-message" v-if="v$.city.$error">{{ $t('nec') }}</div>
            </div>
        </div>

        <!-- <div class="field">
            <label class="label">{{ $t('Sub Province')}} <span class="required">*</span></label>
            <div class="control">
                <input v-model="subProvince" class="input" type="text">
                <div class="has-text-error-message" v-if="v$.subProvince.$error">{{ $t('nec') }}</div>
            </div>
        </div> -->
        
        <div class="field">
            <label class="label">{{ $t('Province')}} <span class="required">*</span></label>
            <div class="control">
                <input v-model="province" class="input" type="text">
                <div class="has-text-error-message" v-if="v$.province.$error">{{ $t('nec') }}</div>
            </div>
        </div>
        
         <div class="field">
            <label class="label">{{ $t('Country')}} <span class="required">*</span></label>
            <div class="control">
                <select v-model="country">
                    <option v-for="country in countries" :value="country.value" :key="country.label">
                    {{ country.label }}
                    </option>
                </select>
                <div class="has-text-error-message" v-if="v$.country.$error">{{ $t('nec') }}</div>
            </div>
            
        </div>
        

        <div class="field">
            <label class="label">{{ $t('Contact phone')}}</label>
            <div class="control">
            <input v-model="phone" type="tel" class="input" >
            <div class="has-text-error-message" v-if="v$.phone.$error">{{ $t('tel') }}</div>
            </div>
        </div>

        <!-- <div class="field">
            <label class="label">{{ $t('Post Code')}}<span class="required">*</span></label>
            <div class="control">
                <input v-model="postCode" class="input" type="text">
                <div class="has-text-error-message" v-if="v$.postCode.$error">{{ $t('nec') }}</div>
            </div>
        </div> -->

        <div class="field">
            <label class="label">{{ $t('ABOUT/CURRICULUM')}}<span class="required">*</span></label>
            <div class="control">
                <textarea style="height: 100px" v-model="text" class="input" type="text"></textarea>
                <div class="has-text-error-message" v-if="v$.text.$error">{{ $t('nec') }}</div>
            </div>
        </div>
        

        <div class="field">
            <label class="label">{{ $t('Email')}}</label>
            <div class="control">
                <input v-model="email" type="email" class="input">
            </div>
            <div class="has-text-error-message" v-if="v$.email.$error">{{ $t('email') }}</div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Website')}}</label>
            <div class="control">
            <input v-model="website" type="url" class="input" placeholder="https://">
            <div class="has-text-error-message" v-if="v$.website.$error">{{ $t('url') }}</div>
            </div>
        </div>

        <label class="label">{{ $t('PLEASE UPLOAD A PICTURE OF YOU')}} <span class="required">*</span></label>
        <div class="uploader uploader1">
            <file-upload v-show="files.length == 0"
                        input-id="file1"
                        class="has-text-centered "
                        extensions="jpg,jpeg,png"
                        accept="image/jpeg"
                        post-action="/api/upload-image/"
                        ref="file1"
                        v-model="files"
                        :headers="{'X-CSRFTOKEN': csrf}"
                        :drop="'.uploader1'"
                        :size="1024 * 1024 *4"
                        @input-filter="inputFilter"
                        @input-file="inputFile"
            >
            <div>
                <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB')}}.
                <br>
                {{ $t('Allowed file types: gif jpg jpeg')}}.
                </div>
            </div>

            </file-upload>
            <div v-if="files.length > 0">
            <div class="columns is-gapless">
                <div class="column is-4">
                <img
                    :src="files.length ? files[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                    class="upload-photo"/>
                </div>
                <div class="column">
                <div>
                    <p class="pb-5">{{ files[0].name }}</p>

                    <button
                        style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                        class="button is-uppercase has-text-weight-bold has-text-white" @click="files=[]"
                        type="button">X
                    </button>
                </div>
                </div>
            </div>
            </div>
            <div class="has-text-error-message" v-if="v$.image.$error">{{ $t('nec') }}</div>
        </div>

        <br>
        <div class="field">
            <input v-model="newsletter" class="is-checkradio" id="exampleRtlCheckbox6" type="checkbox"
                name="exampleRtlCheckbox2"
                checked="checked">
            <label for="exampleRtlCheckbox6">{{ $t('Please subscribe me to your newsletter')}}</label>
        </div>

        <br>
        <div class="field">
            <input v-model="termsAndConditions" class="is-checkradio" id="termsAndConditionsCheckbox" type="checkbox" name="termsAndConditionsCheckbox"
                checked="checked">
                        <label for="termsAndConditionsCheckbox">{{ $t('I accept the conditions laid out in the')}}
                          <a target="_blank" style="color: #D37700; text-decoration: underline" href="https://www.sherry.wine/es/privacy">{{ $t('Privacy Policy')}}</a>
                          <span class="required"> *</span>
                        </label>
            <div class="has-text-error-message" v-if="v$.termsAndConditions.$error">{{ $t('nec')}}{{ $t('nec') }}</div>
        </div>

        <div class="pt-5">
            <button style="background: #D37700; font-size: 14px; padding: 20px 40px;border: none"
                    type="submit" class="button is-uppercase has-text-white has-text-weight-bold ">{{ $t('Send')}}
            </button>
        </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {required, email, integer, url, helpers, requiredIf} from '@vuelidate/validators';
import VueUploadComponent from 'vue-upload-component';
import axios from "axios";

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

const phone = helpers.regex(/^\+34[0-9 ]{5,10}$/);
//const urlx = helpers.regex(/^http.*$/);

import FileComponent from "./FileComponent.vue";

const hasddress = (value, siblings) => {
  console.log("siblings");
  console.log(siblings);
  return true && value;
};

const countries = require('i18n-iso-countries')
countries.registerLocale(require('i18n-iso-countries/langs/en.json'))

export default {

  setup() {
    return {v$: useVuelidate()};
  },
  name: 'Educators',
  components: {
    'file-upload': VueUploadComponent,
    'file-component': FileComponent,
  },
  props: {
    csrf: String,
    lang: String,
    waglocale: String
  },
  data() {
      return {
        nec: "Este campo es necesario",
        mail: "Este campo tiene que ser un email",
        url: "Este campo tiene que ser un url",
        tel: "Este campo tiene que ser telefono",
        cpe: "Este campo tiene que un código postal",
        
        success: false,
        
        // title: '',
        firstName: '',
        surName: '',
        jobTitle: '',
        company: '',
        address: '',
        city: '',
        // subProvince: '',
        province: '',
        country: null,
        phone: '',
        // postCode: '',
        email: '',
        website: '',
        newsletter: '',
        text: '',

        image: null,

        files: [],
        termsAndConditions: null,
      }
  },
  validations() {
    function termsAgreed() {
      return this.termsAndConditions
    }
    return {
      // title: {required},
      surName: {required},
      address: {required},
      city: {required},
      province: {required},
      // subProvince: {required},
      country: {required},
      phone: {integer},
      // postCode: {required},
      email: {email},
      website: {url},
      
      image: {required},
      termsAndConditions: {required, termsAgreed},
      text: {required}

    };
  },
  methods: {
    doSuccess() {
      this.success = true;
      //this.scrollToClass('event')
      window.scrollTo(0, 0);
    },

    async submit() {
        const result = await this.v$.$validate();
        if (!result) {
            console.log("submit validate error");
            // notify user form is invalid
            this.scrollToClass('has-text-error-message');
            return;
        }

        const formData = {
            // title: this.title,
            firstName: this.firstName,
            surName: this.surName,
            jobTitle: this.jobTitle,
            company: this.company,
            address: this.address,
            city: this.city,
            // subProvince: this.subProvince,
            province: this.province,
            country: this.country,
            phone: this.phone,
            // postCode: this.postCode,
            email: this.email,
            website: this.website,
            newsletter: this.newsletter,
            image: this.image,
            text: this.text,
            waglocale: this.waglocale
        };
        
        console.log("formData", formData)
        axios.post("/api/educator/", formData)
            .then((res) => {
                console.log(res);
                this.doSuccess();
                // this.success = true;
            })
            .catch((err) => {
                alert("Ha habido un error, contacta con soporte");
            });
    },
    scrollToClass(className) {
      const el = this.$el.getElementsByClassName('has-text-error-message')[0];
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
      }
    },
    async inputFile(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file1.active) {
          this.$refs.file1.active = true;
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {

      if (newFile && !oldFile) {

        if (!newFile.name.match((/.png|.jpg|.gif$/))) {
          alert("El archivo tiene que ser png o jpg");
          return prevent();
        }
      }

      if (newFile.size > 1024 * 1024 * 4) {
        alert("El archivo tiene que tener menos de 4 MB");
        return prevent();
      }

      if (newFile && newFile.error === "" && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = '';
        let URL = (window.URL || window.webkitURL);
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }
      }
    },

  },
  watch: {
      files: {
        handler: function (files, oldVal) {
          if(files.length > 0 && files[0].response && files[0].response.id){
            this.image = files[0].response.id
            return
          }
          this.image = null
        },
        deep: true
      },
    },
  computed: {
    countries () {
      const list = countries.getNames('en', { select: 'official' })
      return Object.keys(list).map((key) => ({ value: key, label: list[key] }))
    }
  },
  mounted() {
    this.$i18n.locale = this.lang;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.is-checkradio[type=checkbox] + label::after, .is-checkradio[type=checkbox] + label:after {
  color: #292624;
  border-color: #292624;

}

.is-checkradio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before {
  background: #FBF5EF;

}


label.label {
  margin-top: 30px;
}

dio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before, .is-checkradio[type=radio] + label::before, .is-checkradio[type=radio] + label:before {
  border-color: #FBF5EF;
}

.is-checkradio[type=checkbox]:hover:not([disabled]) + label::before, .is-checkradio[type=checkbox]:hover:not([disabled]) + label:before, .is-checkradio[type=radio]:hover:not([disabled]) + label::before, .is-checkradio[type=radio]:hover:not([disabled]) + label:before {
  border-color: #d37700 !important;

}

.uploader {
  padding: 30px;
  background: #FBF5EF;
  border: 1px dashed #C3B193;
  border-radius: 10px;
  width: 100%;
  display: block;

}

.has-text-error-message {
  background: darkred;
  color: white !important;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: 600;
  margin-top: 3px;
  display: block;
}

.upload-photo {
  width: 90%;
  height: auto;
  display: block;

}

</style>